// employeeAPIService.jsx

import axios from "axios";

// Set the base URL for your backend API
axios.defaults.baseURL = 'https://pharmabackend-production.up.railway.app/';

//get employees
const getEmployees = async ()=>{
    try {
        const response = await axios.get("/api/v1/profile/employees/all/",{
            headers:{
                "Content-Type": "application/json",
            },                                
        });
        return response.data
    } catch (error) {
        console.error("Error getting employees:", error);
        throw error; // Rethrow the error to propagate it to the caller
    }
};

const employeeAPIService = {getEmployees};

export default employeeAPIService;

// // update employee status
// const updateEmployeeStatus = async (employeeId, status) => {
//     const response = await axios.put(`/api/v1/profile/employees/${employeeId}`, { updatedStatus: status });
//     return response.data;
//   }
